/**
 * View component for /sentiment-questions/:sentimentQuestionId
 *
 * Displays a single sentimentQuestion from the 'byId' map in the sentimentQuestion reducer
 * as defined by the 'selected' property
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';

// import actions
import * as sentimentQuestionActions from '../sentimentQuestionActions';
import * as sentimentAnswerActions from '../../sentimentAnswer/sentimentAnswerActions'; 

// import global components
import Base from "../../../global/components/BaseComponent.js.jsx";
import Breadcrumbs from '../../../global/components/routing/Breadcrumbs.js.jsx';

// import sentimentQuestion components
import SentimentQuestionLayout from '../components/SentimentQuestionLayout.js.jsx';

// import sentimentQuestion css modules
import sentimentQuestionStyles from '../sentimentQuestionModuleStyles.css';


class SingleSentimentQuestion extends Base {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const { dispatch, match } = this.props;
    dispatch(sentimentQuestionActions.fetchSingleIfNeeded(match.params.sentimentQuestionId));
    dispatch(sentimentAnswerActions.fetchListIfNeeded('_sentimentQuestion', match.params.sentimentQuestionId)); 
  }

  render() {
    const { sentimentQuestionStore, sentimentAnswerStore, location } = this.props;

    /**
     * use the selected.getItem() utility to pull the actual sentimentQuestion object from the map
     */
    const selectedSentimentQuestion = sentimentQuestionStore.selected.getItem();

    const sentimentAnswerList = selectedSentimentQuestion && sentimentAnswerStore.util.getList('_sentimentQuestion', selectedSentimentQuestion._id); 

    const isEmpty = (
      !selectedSentimentQuestion
      || !selectedSentimentQuestion._id
      || sentimentQuestionStore.selected.didInvalidate
    );

    return (
        <div className="flex">
          <section className="section">
            <div className="yt-container">
              <Breadcrumbs links={location.state.breadcrumbs} />
              <h3> Sentiment Question 
                <Link className="yt-btn small u-pullRight" to={`${this.props.match.url}/update`}> UPDATE Sentiment Question </Link>
              </h3>
              {isEmpty ?
                (sentimentQuestionStore.isFetching ? <h2>Loading...</h2> : <h2>Empty.</h2>)
                :
                <div style={{ opacity: sentimentQuestionStore.isFetching ? 0.5 : 1 }}>
                  <hr/>
                  <p><b>Text/Title:</b> {selectedSentimentQuestion.text}</p>
                  <p> <b>Rating Type:</b> {selectedSentimentQuestion.ratingType}</p>
                  <p> <b>Status:</b> {selectedSentimentQuestion.status}</p>
                  <p> <b>Order Weight:</b> {selectedSentimentQuestion.orderWeight}</p>
                </div>
              }
              {sentimentAnswerList && sentimentAnswerList.length > 0 ? 
                <div>
                  <h4>User Sentiment:</h4>
                  <hr/>
                  { selectedSentimentQuestion.ratingType == 'stars' ? 
                    <div>
                      <p> <b>5 stars:</b> {Math.round(( sentimentAnswerList.filter(ans => ans.rating === 5).length / sentimentAnswerList.length) * 100)}%</p>
                      <p> <b>4 stars:</b> {Math.round(( sentimentAnswerList.filter(ans => ans.rating === 4).length / sentimentAnswerList.length) * 100)}%</p>
                      <p> <b>3 stars:</b> {Math.round(( sentimentAnswerList.filter(ans => ans.rating === 3).length / sentimentAnswerList.length) * 100)}%</p>
                      <p> <b>2 stars:</b> {Math.round(( sentimentAnswerList.filter(ans => ans.rating === 2).length / sentimentAnswerList.length) * 100)}%</p>
                      <p> <b>1 star:</b> {Math.round(( sentimentAnswerList.filter(ans => ans.rating === 1).length / sentimentAnswerList.length) * 100)}%</p>
                    </div>
                  : selectedSentimentQuestion.ratingType == 'thumbs' ? 
                    <div>
                      <p> <b>Thumbs Up:</b> {Math.round(( sentimentAnswerList.filter(ans => ans.rating === 1).length / sentimentAnswerList.length) * 100)}%</p>
                      <p> <b>Thumbs Down:</b> {Math.round(( sentimentAnswerList.filter(ans => ans.rating === 2).length / sentimentAnswerList.length) * 100)}%</p>
                    </div>
                  : selectedSentimentQuestion.ratingType == 'confidence' ? 
                    <div>
                      <p> <b>10:</b> {Math.round(( sentimentAnswerList.filter(ans => ans.rating === 10).length / sentimentAnswerList.length) * 100)}%</p>
                      <p> <b>9:</b> {Math.round(( sentimentAnswerList.filter(ans => ans.rating === 9).length / sentimentAnswerList.length) * 100)}%</p>
                      <p> <b>8:</b> {Math.round(( sentimentAnswerList.filter(ans => ans.rating === 8).length / sentimentAnswerList.length) * 100)}%</p>
                      <p> <b>7:</b> {Math.round(( sentimentAnswerList.filter(ans => ans.rating === 7).length / sentimentAnswerList.length) * 100)}%</p>
                      <p> <b>6:</b> {Math.round(( sentimentAnswerList.filter(ans => ans.rating === 6).length / sentimentAnswerList.length) * 100)}%</p>
                      <p> <b>5:</b> {Math.round(( sentimentAnswerList.filter(ans => ans.rating === 5).length / sentimentAnswerList.length) * 100)}%</p>
                      <p> <b>4:</b> {Math.round(( sentimentAnswerList.filter(ans => ans.rating === 4).length / sentimentAnswerList.length) * 100)}%</p>
                      <p> <b>3:</b> {Math.round(( sentimentAnswerList.filter(ans => ans.rating === 3).length / sentimentAnswerList.length) * 100)}%</p>
                      <p> <b>2:</b> {Math.round(( sentimentAnswerList.filter(ans => ans.rating === 2).length / sentimentAnswerList.length) * 100)}%</p>
                      <p> <b>1::</b> {Math.round(( sentimentAnswerList.filter(ans => ans.rating === 1).length / sentimentAnswerList.length) * 100)}%</p>
                    </div>
                  : null
                  }
                </div>
              : null
              }
            </div>
          </section>
        </div>
    )
  }
}

SingleSentimentQuestion.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    sentimentQuestionStore: store.sentimentQuestion
    , sentimentAnswerStore: store.sentimentAnswer
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(SingleSentimentQuestion)
);



// WEBPACK FOOTER //
// modules/sentimentQuestion/views/SingleSentimentQuestion.js.jsx